import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ExpandOurNetwork() {
  return <section id="expand-our-network" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636043/img/logistics_map_bg.png)] bg-cover bg-center opacity-20 pointer-events-none" aria-hidden="true" />

      {}
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center flex flex-col items-center">
        <h2 className="font-default text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight mb-6 text-foreground">
          Join the National Fleet.
        </h2>
        
        <p className="font-default text-lg sm:text-xl text-muted-foreground mb-10 max-w-2xl">
          Partner with PottyForSale.com and become part of the premier national network of certified sanitation operators. Expand your reach and service enterprise-level clients today.
        </p>
        
        <Link to="#">
          <Button size="lg" className="text-lg px-10 py-6 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
            Apply as Partner
          </Button>
        </Link>
      </div>
    </section>;
}